const SKIP_CLASSES = ['ant-motion', 'ant-fade', 'ant-zoom', 'ant-slide']

const isUtilityClass = c => {
  if (!c) return true
  if (c.startsWith('ant-motion-')) return true
  if (c.startsWith('ant-fade-')) return true
  if (c.startsWith('css-')) return true
  return SKIP_CLASSES.some(s => c.startsWith(s))
}

const escapeClass = c => c.replace(/([^\w-])/g, '\\$1')

const segmentForNode = node => {
  const tag = node.tagName.toLowerCase()
  if (node.id) {
    return `#${CSS.escape(node.id)}`
  }
  const classes = Array.from(node.classList)
    .filter(c => !isUtilityClass(c))
    .slice(0, 3)
  if (classes.length > 0) {
    return `${tag}.${classes.map(escapeClass).join('.')}`
  }
  const parent = node.parentElement
  if (parent) {
    const siblings = Array.from(parent.children).filter(c => c.tagName === node.tagName)
    if (siblings.length > 1) {
      const idx = siblings.indexOf(node) + 1
      return `${tag}:nth-of-type(${idx})`
    }
  }
  return tag
}

export const getCssSelector = node => {
  if (!node || node.nodeType !== 1) return null
  if (node === document.body) return 'body'

  const segments = []
  let current = node
  while (current && current !== document.body && current.nodeType === 1) {
    segments.unshift(segmentForNode(current))
    if (current.id) break
    current = current.parentElement
  }
  return segments.join(' > ')
}
